// @ts-check
import { useDispatch } from 'react-redux';
import useSessionManager from '../../../HOC/TokenHandler/useSessionManager';
import { setAccount } from '../../../RTK/account';
import { getAccount } from '../../../common/clients/accounts.service';
import { identify, trackEvents } from '../../../services/analytics';
import { useLocation, useNavigate } from 'react-router-dom';
import { useComponentDidMount } from '../../../hooks/useComponentDidMount';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { getLDContext } from '../../../common/utils/getLDContext';
import BrowserStorageAccessor from '../../../common/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS } from '../../../common/consts';

export const useLoadRootData = (redirectToLoginOnFail = true) => {
  const ldClient = useLDClient();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [clearSession] = useSessionManager();
  const browserStorageAccessor = BrowserStorageAccessor();

  useComponentDidMount(() => {
    async function handle() {
      try {
        const account = await getAccount();

        identify(account);
        ldClient.identify(getLDContext(account));
        trackEvents.login();

        // Logging the visit here instead of <PageAnalytics/> because the user is not identified there yet
        trackEvents.visit(location.pathname);
        const lastLocation = browserStorageAccessor.local.get(
          LOCAL_STORAGE_KEYS.LAST_LOCATION
        );
        dispatch(setAccount(account));
        if (lastLocation) {
          navigate(lastLocation);
          browserStorageAccessor.local.remove(LOCAL_STORAGE_KEYS.LAST_LOCATION);
        }
      } catch (error) {
        await clearSession(redirectToLoginOnFail);
      }
    }

    handle();
  });
};
